// Which parts of the app talk to the real Django backend (ChatBizz_Backend).
//
// Mock mode (REACT_APP_USE_MOCK not "false", e.g. `npm test`): everything runs on the in-browser mock, as before.
// Backend mode (REACT_APP_USE_MOCK=false, see .env.development): only the endpoints below go to the backend.
// Every other endpoint is refused locally with code NOT_CONNECTED (no request is sent) and its screen shows
// a "Coming soon — not connected" state. To connect another screen once its backend API exists, add its
// endpoint(s) to CONNECTED_ENDPOINTS and its route to CONNECTED_PAGES.

export const USE_MOCK = process.env.REACT_APP_USE_MOCK !== "false";
export const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/+$/, "");

const ID = "[\\w-]+";

/** [HTTP methods, path pattern] — paths as the frontend writes them (no trailing slash, no query string). */
const CONNECTED_ENDPOINTS = [
  // Auth
  [["POST"], /^\/api\/auth\/(login|logout|register|verify-email|resend-code|forgot-password|reset-password|deactivate|token\/refresh)$/],
  [["GET"], /^\/api\/auth\/me$/],
  // Team users & roles
  [["GET", "POST"], /^\/api\/team\/members$/],
  [["PATCH"], new RegExp(`^/api/team/members/${ID}$`)],
  [["POST"], new RegExp(`^/api/team/members/${ID}/status$`)],
  // Business (tenant) profile — used by Settings → Business profile and Business settings
  [["GET", "PATCH"], /^\/api\/business-profile$/],
  // Workspace settings — Settings → Workspace
  [["GET", "PUT"], /^\/api\/settings$/]
];

/** Public auth endpoints: no Bearer token needed, and a 401 from them never means "your session expired". */
export const PUBLIC_ENDPOINTS = /^\/api\/auth\/(login|register|verify-email|resend-code|forgot-password|reset-password|token\/refresh)$/;

/** Signed-in endpoints where a dead session is expected and must not open the "Session expired" screen. */
export const QUIET_ENDPOINTS = /^\/api\/auth\/logout$/;

export const REFRESH_ENDPOINT = "/api/auth/token/refresh";

/** Screens (routes) whose data comes entirely from connected endpoints. */
const CONNECTED_PAGES = ["/settings", "/business-profile", "/business-settings", "/team-members"];

/** Tabs inside "Marketing & Team, Integrations" that are connected. */
const CONNECTED_MARKETING_SECTIONS = ["team"];

export const pathOf = (url) => String(url || "").split("?")[0].replace(/\/+$/, "") || "/";

export function isEndpointConnected(method, url) {
  if (USE_MOCK) return true;
  const verb = String(method || "GET").toUpperCase();
  const path = pathOf(url);
  return CONNECTED_ENDPOINTS.some(([methods, pattern]) => methods.includes(verb) && pattern.test(path));
}

export const isPageConnected = (route) => USE_MOCK || CONNECTED_PAGES.includes(pathOf(route));

export const isMarketingSectionConnected = (id) => USE_MOCK || CONNECTED_MARKETING_SECTIONS.includes(id);

/** Connected screens a signed-in user can jump to from a "not connected" page: [route, label, permission]. */
export const AVAILABLE_SCREENS = [
  ["/team-members", "Team users & roles", "users:manage"],
  ["/business-profile", "Business profile", "business:manage"],
  ["/business-settings", "Business settings", "business:manage"],
  ["/settings", "Workspace settings", "business:manage"]
];
